import React from "react";
import { Icon, IconName } from "../icon";

import "./badge.css";

/** Only the badge component */
export const Badge = ({
	value,
	iconName,
	className,
	disabled = false,
}: {
	value?: string;
	iconName?: IconName;
	className?: string;
	disabled?: boolean;
}) => {
	if (!iconName && !value) return null;
	return (
		<div
			className={`badge ${iconName ? "badge--is-icon" : ""} ${className || ""} ${
				disabled ? "badge--is-disabled" : ""
			}`}
		>
			{iconName ? <Icon iconName={iconName} /> : value}
		</div>
	);
};
Badge.displayName = "Badge";

/** Wrap your component with this component to add a badge around it */
export const BadgeWrapper = ({
	value,
	iconName,
	className,
	badgeClassName,
	children,
}: React.PropsWithChildren<{
	value?: string;
	iconName?: IconName;
	className?: string;
	badgeClassName?: string;
}>) => (
	<div className={`badge__wrapper ${className || ""}`}>
		{children}
		<Badge className={badgeClassName} value={value} iconName={iconName} />
	</div>
);
BadgeWrapper.displayName = "BadgeWrapper";
